import React, {
  createContext,
  useContext,
  useState
} from "react";

const IndustryContext = createContext();

export function IndustryProvider({ children }) {

  const [industry, setIndustry] =
    useState("School");

  return (
    <IndustryContext.Provider
      value={{
        industry,
        setIndustry
      }}
    >
      {children}
    </IndustryContext.Provider>
  );
}

export function useIndustry() {
  return useContext(IndustryContext);
}